var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showStatus
    ? _c("div", { staticClass: "product-status-wrapper" }, [
        _c("div", { staticClass: "status", class: _vm.cssClasses }, [
          _vm.isInStock
            ? _c("p", { staticClass: "available" }, [
                _vm._v(_vm._s(_vm.$t("available")))
              ])
            : _c("p", { staticClass: "unavailable" }, [
                _vm._v(_vm._s(_vm.$t("unavailable")))
              ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }